import { computed, defineComponent, ref } from 'vue';
import { useSweetAlert } from '@/composables/sweetalert';
import { useStore } from 'vuex';
import { ProjectAction, ProjectGetter } from '@/store/project/project.module';
import { Project, ProjectAttachment } from '@/store/project/project.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProjectAttachmentModelComponent',
  components: {
    BaseModalComponent
  },
  props: {
    projectId: {
      type: Number,
    }
  },
  emits: [
    'upload',
    'hidden',
  ],
  setup: (props, context) => {
    const swal = useSweetAlert();
    const store = useStore();
    const project = computed<Project>(() => store.getters[ProjectGetter.BY_ID](props.projectId));
    const attachments = computed<ProjectAttachment[]>(() => (project.value) ? project.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const isLoading = computed<boolean>(() => store.getters[ProjectGetter.STATUS] === 'init' || store.getters[ProjectGetter.STATUS] === 'loading');
    const attachmentModal = ref<InstanceType<typeof BaseModalComponent>>();

    // show modal
    const show = () => {
      attachmentModal.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentModal.value?.hide();
    };

    // upload click
    const uploadClick = () => {
      context.emit('upload', project.value?.id);
    };

    // delete click
    const deleleClick = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ProjectAction.REMOVE_ATTACHMENTS, {
              fiscalYearId: project.value?.fiscalYear.id,
              projectId: project.value?.id,
              attachmentIds: [id],
            });
          }
        });
    };

    // hidden
    const handleHidden = () => {
      context.emit('hidden', project.value?.id);
    };

    return {
      attachments,
      attachmentModal,
      isLoading,
      show,
      hide,
      uploadClick,
      deleleClick,
      handleHidden,
    };
  },
});
